export enum AnalyzeConsumptionType {
  Energy = 'energy',
  NormalEnergy = 'normalEnergy',
  Waterflow = 'waterflow',
  Evmrt = 'Evmrt',
  ReturnTemp = 'ReturnTemp',
  SupplyTemp = 'SupplyTemp',
  Power = 'Power',
  Economy = 'Economy',
  NormalEnergyCombined = 'normalEnergyCombined'
}
